<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">Price List Master</h1>
    <app-navpath class="hidden md:block" />
  </div>
  <div class="mb-2 flex w-full flex-col gap-2 xl:flex-row xl:justify-between">
    <div class="flex w-full flex-col gap-1 md:flex-row xl:w-auto">
      <button class="shorter-btn misc-btn" (click)="addEntry()">
        <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Add
      </button>
      <button
        class="shorter-btn delete-btn"
        (click)="onDeleteClick()"
      >
        <fa-icon [icon]="faTrash" class="mr-1"></fa-icon>Delete
      </button>
      <button class="shorter-btn misc-btn" (click)="print()">
        <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Print
      </button>
      <app-search-input
        (dataOutput)="onSearch($event)"
        [isTable]="true"
        class="block w-full md:w-auto"
      ></app-search-input>
    </div>
    <div class="flex w-full flex-col gap-1 md:flex-row xl:w-auto">
      <button
        class="shorter-btn misc-btn"
        (click)="openModal('passenger', true)"
      >
        <fa-icon [icon]="faPencil" class="mr-1"></fa-icon>Passenger
        Remarks
      </button>
      <button
        class="shorter-btn misc-btn"
        (click)="openModal('commercial', true)"
      >
        <fa-icon [icon]="faPencil" class="mr-1"></fa-icon>Commercial
        Remarks
      </button>
    </div>
  </div>
  <div class="content-container">
    <button
      type="button"
      class="section-toggle"
      (click)="togglePriceSection('list')"
      [attr.aria-expanded]="listPricesExpanded"
      aria-controls="list-prices-table"
    >
      <span class="sub-heading border-b">List Prices</span>
      <fa-icon [icon]="listPricesExpanded ? faMinus : faPlus" />
    </button>
    <div
      *ngIf="listPricesExpanded"
      id="list-prices-table"
      class="w-full overflow-x-auto"
    >
      <app-data-table
        class="block min-w-[88rem]"
        [tableHeaders]="listPricesHeaders"
        [tableEntries]="filteredListPrices"
        (open)="openEntry($event)"
        [pagination]="false"
      ></app-data-table>
    </div>
  </div>
  <div class="content-container">
    <button
      type="button"
      class="section-toggle"
      (click)="togglePriceSection('sales')"
      [attr.aria-expanded]="salesPricesExpanded"
      aria-controls="sales-prices-table"
    >
      <span class="sub-heading border-b">Sales Prices</span>
      <fa-icon [icon]="salesPricesExpanded ? faMinus : faPlus" />
    </button>
    <div
      *ngIf="salesPricesExpanded"
      id="sales-prices-table"
      class="w-full overflow-x-auto"
    >
      <app-data-table
        class="block min-w-[82rem]"
        [tableHeaders]="salesPricesHeaders"
        [tableEntries]="filteredSalesPrices"
        [pagination]="false"
      ></app-data-table>
    </div>
  </div>
</section>
<div class="bg-modal" *ngIf="showPassenger">
  <div
    class="container-remarks"
    role="dialog"
    aria-modal="true"
    aria-labelledby="passenger-remarks-title"
  >
    <h2 id="passenger-remarks-title" class="sub-heading w-full border-b">
      Update Passenger Remarks
    </h2>
    <app-data-form [dataFields]="passengerRemarksForm" />
    <div class="flex w-full flex-col gap-2 border-t pt-4 sm:flex-row sm:justify-end">
      <button
        class="shorter-btn save-btn"
        (click)="saveRemarks('passenger')"
      >
        <fa-icon [icon]="faEdit" class="mr-1"></fa-icon>Update
      </button>
      <button
        class="shorter-btn clear-btn"
        (click)="openModal('passenger', false)"
      >
        <fa-icon [icon]="faCancel" class="mr-1"></fa-icon>Cancel
      </button>
    </div>
  </div>
</div>
<div class="bg-modal" *ngIf="showCommercial">
  <div
    class="container-remarks"
    role="dialog"
    aria-modal="true"
    aria-labelledby="commercial-remarks-title"
  >
    <h2 id="commercial-remarks-title" class="sub-heading w-full border-b">
      Update Commercial Remarks
    </h2>
    <app-data-form [dataFields]="commercialRemarksForm" />
    <div class="flex w-full flex-col gap-2 border-t pt-4 sm:flex-row sm:justify-end">
      <button
        class="shorter-btn save-btn"
        (click)="saveRemarks('commercial')"
      >
        <fa-icon [icon]="faEdit" class="mr-1"></fa-icon>Update
      </button>
      <button
        class="shorter-btn clear-btn"
        (click)="openModal('commercial', false)"
      >
        <fa-icon [icon]="faCancel" class="mr-1"></fa-icon>Cancel
      </button>
    </div>
  </div>
</div>
